module.exports = __webpack_public_path__ + "img/cgwx.e25a55b9.png";